const padrao_visualizacao = {
    criar: false,
    deletar: false,
    editar: false,
    visualizar: true
};

const padrao_completo = {
    criar: true,
    deletar: true,
    editar: true,
    visualizar: true
}

const padrao_sem_permissoes = {
    criar: false,
    deletar: false,
    editar: false,
    visualizar: false
}

export const rotasPermissao = {
    admin: {
        admin: padrao_visualizacao,
        boletim: padrao_completo,
        estacionamento: padrao_completo,
        logs: padrao_visualizacao,
        loja: padrao_completo,
        municipio: padrao_completo,
        permissoes: padrao_completo,
        pessoa: padrao_completo,
        produto: padrao_completo,
        produtoGrupo: padrao_completo,
        propriedade: padrao_completo,
        precos: padrao_completo,
        romaneio: padrao_completo,
        rotas: padrao_completo,
        vaf: padrao_visualizacao
    },
    agro: {
        admin: padrao_visualizacao,
        boletim: padrao_visualizacao,
        estacionamento: padrao_visualizacao,
        logs: padrao_sem_permissoes,
        loja: padrao_visualizacao,
        municipio: padrao_visualizacao,
        permissoes: padrao_sem_permissoes,
        pessoa: padrao_visualizacao,
        produto: padrao_visualizacao,
        produtoGrupo: padrao_visualizacao,
        propriedade: padrao_visualizacao,
        precos: padrao_visualizacao,
        romaneio: padrao_visualizacao,
        rotas: padrao_sem_permissoes,
        vaf: padrao_visualizacao
    }
}

export const permissions_check = (rota, permissao, permissoes) => {
    return permissoes[rota]?.[permissao];
}
